import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=4e6c812d&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6c812d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e6c812d')) {
      api.createRecord('4e6c812d', component.options)
    } else {
      api.reload('4e6c812d', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=4e6c812d&scoped=true", function () {
      api.rerender('4e6c812d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/platformManagement/customerServiceManagement/orderList/detail.vue"
export default component.exports